/**
 * PATH: apps/qa/src/lib/api/dashboard.ts
 * PURPOSE: Dashboard stats and auth API
 */

import { api } from './helpers'
import type { DashboardStats } from '@/types/qa'

export const dashboardApi = {
  getDashboardStats: async (): Promise<DashboardStats> => {
    const response = await api().get('/qa/dashboard/')
    if (response.data && typeof response.data === 'object' && 'stats' in response.data) return response.data.stats
    return response.data ?? {} as DashboardStats
  },
}

export const authApi = {
  getProfile: async () => api().get('/auth/profile/'),
  validateToken: async () => { const r = await api().get('/auth/profile/'); return r.data },
}
